module.exports = __webpack_public_path__ + "img/button_share_old.cefd360f.png";